import { render } from "./SmartSessionEndPage.vue?vue&type=template&id=4a24f3fa&ts=true"
import script from "./SmartSessionEndPage.vue?vue&type=script&lang=ts"
export * from "./SmartSessionEndPage.vue?vue&type=script&lang=ts"

import "./SmartSessionEndPage.vue?vue&type=style&index=0&id=4a24f3fa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__